module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-available-green-9944aa.svg";